// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1f8X2","buttons":"PendingPaymentAlert_buttons__3qeBr"};